<template>
  <form autocomplete="off">
    <div
      v-if="localPage.pageObj"
      v-for="(fieldGroup, fieldsIndex) in localPage.pageObj.fields"
      :key="fieldsIndex"
      v-show="isIfConditionValid(fieldGroup)"
      class="pt-2"
      :data-page-id="localPage.id"
    >
      <Divider
        v-if="
          fieldGroup.show_divider &&
          !(fieldGroup.hide_on_mobile && Helper.isMobileSize())
        "
      />
      <div
        v-if="!fieldGroup.is_multiple"
        :class="
          fieldGroup.max_item_in_mobile_view
            ? `grid gap-2 grid-cols-${fieldGroup.max_item_in_mobile_view} sm:flex sm:flex-row sm:items-center`
            : 'flex flex-wrap sm:flex-nowrap sm:items-center gap-2'
        "
      >
        <div
          v-for="(field, fieldIndex) in fieldGroup.group"
          :key="fieldIndex"
          :class="[
            fieldGroup.disable_auto_alignment
              ? ''
              : `w-full ${
                  Helper.isValueExist(field.width)
                    ? `sm:w-${field.width}/12`
                    : `w-1/${fieldGroup.group.length}`
                }`
          ]"
          v-show="
            isIfConditionValid(field) &&
            (!fieldGroup.max_item_in_mobile_view ||
              !Helper.isMobileSize() ||
              field.fieldObj.field_type !== Constants.enums.FIELD_TYPES.SPACER)
          "
        >
          <FormLabelComponent
            v-if="field.showLabel && !isFieldHidden(field) && field.label"
            :for-tag="field.id"
            :label="field.label"
            :required="field.required"
          />
          <FormInputComponent
            :field="fieldGroup.group[fieldIndex]"
            :selectedPath="selectedPath || []"
            :updateLocalStore="updateLocalStore"
            :clearOnHidden="field.clearOnHidden"
            :isVisible="isIfConditionValid(field)"
            ref="formInputComponents"
            :ignoreOverridePageValue="ignoreOverridePageValue"
          />
        </div>
      </div>
      <!-- if it's multipl list -->
      <div v-if="fieldGroup.is_multiple">
        <div
          v-for="(record, recordIndex) in multipleFieldGroupArray[
            fieldGroup.row_id
          ]"
        >
          <!-- desktop view -->
          <div
            class="flex flex-wrap sm:flex-nowrap sm:items-center gap-2 pt-2 relative"
            v-if="record && !Helper.isMobileSize()"
          >
            <div
              v-for="(field, fieldIndex) in record.group"
              :key="fieldIndex"
              :class="[
                record.disable_auto_alignment
                  ? ''
                  : `w-full ${
                      Helper.isValueExist(field.width)
                        ? `sm:w-${field.width}/12`
                        : `w-1/${record.group.length}`
                    }`
              ]"
              v-show="isIfConditionValid(field, recordIndex, record.row_id)"
            >
              <FormLabelComponent
                v-if="field.showLabel"
                :for-tag="field.id"
                :label="field.label"
                :required="field.required"
              />

              <FormInputComponent
                :field="record.group[fieldIndex]"
                :isMultiple="true"
                :recordIndex="recordIndex"
                :multipleParentId="record.row_id"
                :selectedPath="selectedPath || []"
                :updateLocalStore="updateLocalStore"
                :clearOnHidden="field.clearOnHidden"
                :isVisible="
                  isIfConditionValid(field, recordIndex, record.row_id)
                "
                ref="formInputComponents"
                :ignoreOverridePageValue="ignoreOverridePageValue"
              />
            </div>
            <div
              v-if="
                !Helper.isValueExist(fieldGroup.show_add_or_remove_btns) ||
                fieldGroup.show_add_or_remove_btns != false
              "
              class="flex gap-2 absolute right-0 top-[70%] -translate-y-1/2"
            >
              <Button
                variant="text"
                v-if="fieldGroup.sub_page_id"
                :icon="
                  isSubPageExpanded[recordIndex]
                    ? 'pi pi-chevron-down'
                    : 'pi pi-chevron-up'
                "
                severity="secondary"
                @click="toggleSubPage(recordIndex)"
              />
              <Button
                icon="pi pi-trash"
                severity="danger"
                :disabled="
                  isAnyFieldDisabled(record.group) ||
                  recordIndex < (parseInt(fieldGroup.min_items) || 0)
                "
                v-tooltip="
                  isAnyFieldDisabled(record.group) ||
                  recordIndex < (parseInt(fieldGroup.min_items) || 0)
                    ? 'This item cannot be removed'
                    : ''
                "
                @click="() => onRemoveItemClick(fieldGroup, recordIndex)"
              />
            </div>
          </div>
          <!-- desktop view sub page starts from here -->
          <div
            v-if="fieldGroup.sub_page_id && !Helper.isMobileSize()"
            class="ml-2 sm:ml-4 md:ml-8 lg:ml-10 mr-5"
          >
            <div
              v-if="record.sub_page_group && !isSubPageExpanded[recordIndex]"
            >
              <div
                v-for="(
                  subPageFieldGroup, subPageFieldsIndex
                ) in record.sub_page_group"
                :key="subPageFieldsIndex"
              >
                <Divider v-if="subPageFieldGroup.show_divider" />
                <div
                  class="flex flex-wrap sm:flex-nowrap sm:items-center gap-2 pt-2"
                  v-if="
                    (subPageFieldGroup.showContainMatch &&
                      compareContainMatchForSubFields(
                        subPageFieldGroup,
                        record,
                        recordIndex
                      )) ||
                    (!subPageFieldGroup.showContainMatch &&
                      !subPageFieldGroup.group?.some((field) =>
                        field.label?.startsWith('$(')
                      ))
                  "
                >
                  <div
                    v-for="(
                      subPageField, subPageFieldIndex
                    ) in subPageFieldGroup.group"
                    :key="subPageFieldIndex"
                    :class="[
                      subPageFieldGroup.disable_auto_alignment
                        ? ''
                        : `w-full ${
                            Helper.isValueExist(subPageField.width)
                              ? `sm:w-${subPageField.width}/12`
                              : `w-1/${subPageFieldGroup.group.length}`
                          }`
                    ]"
                    v-show="isIfConditionValid(subPageField)"
                  >
                    <div>
                      <FormLabelComponent
                        v-if="subPageField.showLabel"
                        :for-tag="subPageField.id"
                        :label="subPageField.label"
                        :required="subPageField.required"
                      />
                      <FormInputComponent
                        :field="subPageFieldGroup.group[subPageFieldIndex]"
                        :updateLocalStore="updateLocalStore"
                        :isSubPage="true"
                        :recordIndex="subPageFieldsIndex"
                        :rowGroup="subPageFieldGroup"
                        :multipleParentId="{
                          rowId: fieldGroup.row_id,
                          recordIndex: recordIndex
                        }"
                        :clearOnHidden="subPageField.clearOnHidden"
                        :isVisible="isIfConditionValid(subPageField)"
                        ref="formInputComponents"
                        :ignoreOverridePageValue="true"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Divider v-if="record && !Helper.isMobileSize()" />
          <!-- desktop view sub page ends here -->

          <!-- mobile card view starts from here -->
          <div
            class="flex flex-col w-full gap-2 pt-2"
            v-if="record && Helper.isMobileSize()"
          >
            <Card
              class="cursor-pointer hover:shadow-lg transition-shadow w-full border border-surface-200"
              @click="
                openFieldGroupDialog(
                  multipleFieldGroupArray[fieldGroup.row_id][recordIndex],
                  recordIndex,
                  true
                )
              "
            >
              <template #title>
                <div class="flex items-center justify-between">
                  <!-- card title -->
                  <div
                    v-if="
                      isCardEmpty(
                        fieldGroup.card_title,
                        fieldGroup.card_body,
                        recordIndex,
                        record.row_id
                      )
                    "
                  >
                    {{
                      fieldGroup.fallback_message ||
                      "Click or tap here to open it"
                    }}
                  </div>
                  <!-- Show title if card has content -->
                  <FormInputComponent
                    v-else
                    :field="fieldGroup.card_title || 'Muti List Item'"
                    :isMultiple="true"
                    :recordIndex="recordIndex"
                    :multipleParentId="record.row_id"
                    :updateLocalStore="updateLocalStore"
                    :clearOnHidden="fieldGroup.card_title?.clearOnHidden"
                    :isVisible="true"
                    :ignoreOverridePageValue="ignoreOverridePageValue"
                  />

                  <div class="flex gap-2">
                    <!-- sub page expand/collapse button -->
                    <Button
                      variant="text"
                      v-if="
                        fieldGroup.sub_page_id &&
                        (!Helper.isValueExist(
                          fieldGroup.show_add_or_remove_btns
                        ) ||
                          fieldGroup.show_add_or_remove_btns != false)
                      "
                      :icon="
                        isSubPageExpanded[recordIndex]
                          ? 'pi pi-chevron-down'
                          : 'pi pi-chevron-up'
                      "
                      severity="secondary"
                      @click.stop="toggleSubPage(recordIndex)"
                    />
                    <!-- remove button -->
                    <Button
                      v-if="
                        !Helper.isValueExist(
                          fieldGroup.show_add_or_remove_btns
                        ) || fieldGroup.show_add_or_remove_btns != false
                      "
                      icon="pi pi-trash"
                      severity="danger"
                      :disabled="
                        isAnyFieldDisabled(record.group) ||
                        recordIndex < (parseInt(fieldGroup.min_items) || 0)
                      "
                      v-tooltip="
                        isAnyFieldDisabled(record.group) ||
                        recordIndex < (parseInt(fieldGroup.min_items) || 0)
                          ? 'This item cannot be removed'
                          : ''
                      "
                      @click.stop="
                        () => onRemoveItemClick(fieldGroup, recordIndex)
                      "
                    />
                  </div>
                </div>
              </template>
              <template #content>
                <!-- Only show content if card is not empty -->
                <div
                  class="text-gray-600"
                  v-if="
                    !isCardEmpty(
                      fieldGroup.card_title,
                      fieldGroup.card_body,
                      recordIndex,
                      record.row_id
                    )
                  "
                >
                  <!-- card body -->
                  <FormInputComponent
                    :field="
                      fieldGroup.card_body || 'Click to view and edit fields'
                    "
                    :isMultiple="true"
                    :recordIndex="recordIndex"
                    :multipleParentId="record.row_id"
                    :updateLocalStore="updateLocalStore"
                    :clearOnHidden="fieldGroup.card_body?.clearOnHidden"
                    :isVisible="true"
                    :ignoreOverridePageValue="ignoreOverridePageValue"
                  />
                </div>
              </template>
            </Card>
          </div>
        </div>
        <div class="flex flex-wrap items-center justify-end pt-2 w-full">
          <Button
            v-if="
              !Helper.isValueExist(fieldGroup.show_add_or_remove_btns) ||
              fieldGroup.show_add_or_remove_btns != false
            "
            label="Add More"
            icon="pi pi-plus"
            severity="success"
            :disabled="isAnyFieldDisabled(fieldGroup.group)"
            @click="() => onAddMoreClick(fieldGroup)"
            class="w-full sm:w-auto"
          />
        </div>
      </div>
    </div>
    <div
      v-if="localPage.pageObj"
      v-for="(fieldGroup, fieldsIndex) in localPage.pageObj.fields"
      :key="fieldsIndex"
    >
      <div class="items-center">
        <div
          v-for="(field, fieldIndex) in fieldGroup.group"
          :key="fieldIndex"
        >
          <!-- IN PAGE SELECTED IMAGES / UPLOADED IMAGES -->
          <div
            class="pt-2"
            v-if="
              field.fieldObj.field_type ==
                Constants.enums.FIELD_TYPES.TRIGGER_BTN &&
              (field.onClick ==
                Constants.enums.NAVIGATION_BTN_ACTIONS
                  .ON_CAMERA_SELECT_TRIGGER_BTN ||
                field.onClick ==
                  Constants.enums.NAVIGATION_BTN_ACTIONS
                    .ON_FILE_SELECT_TRIGGER_BTN) &&
              field.imagePreviewType ==
                Constants.enums.IMAGE_PREVIEW_TYPE.IN_PAGE
            "
          >
            <div v-if="field.value && field.value.length > 0">
              <Tag
                class="mb-2 text-lg text-gray-700 font-bold"
                severity="info"
                :value="field.label"
              ></Tag>
              <div class="border border-surface-200 p-4">
                <AttachmentsGridComponent
                  :attachments="field.value"
                  :disableDelete="field.disabled"
                  @update:attachments="
                    (attachments) => onUpdateAttachments(attachments, field.id)
                  "
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>

  <!-- Field Group Dialog -->
  <Dialog
    v-model:visible="fieldGroupDialog.visible"
    :header="fieldGroupDialog.title"
    :style="getCardDialogStyle"
    :modal="true"
    :closable="true"
    :dismissableMask="true"
  >
    <div class="flex flex-col gap-4">
      <!-- Dialog Description Top -->
      <FormInputComponent
        v-if="
          fieldGroupDialog.dialogDescription &&
          (!fieldGroupDialog.dialogDescription.position ||
            fieldGroupDialog.dialogDescription.position === 'top')
        "
        :field="fieldGroupDialog.dialogDescription"
        :updateLocalStore="false"
        :clearOnHidden="fieldGroupDialog.dialogDescription?.clearOnHidden"
        :isVisible="true"
        :ignoreOverridePageValue="ignoreOverridePageValue"
      />

      <!-- Dialog Buttons Top -->
      <div class="flex justify-end">
        <FormInputComponent
          v-if="
            fieldGroupDialog.dialogButtons &&
            (!fieldGroupDialog.dialogButtons.position ||
              fieldGroupDialog.dialogButtons.position === 'top')
          "
          :field="fieldGroupDialog.dialogButtons"
          :updateLocalStore="false"
          :clearOnHidden="fieldGroupDialog.dialogButtons?.clearOnHidden"
          :isVisible="true"
          :ignoreOverridePageValue="ignoreOverridePageValue"
        />
      </div>

      <!-- Main group fields -->
      <div
        v-for="(field, fieldIndex) in fieldGroupDialog.fields"
        v-show="
          isIfConditionValid(
            field,
            fieldGroupDialog.recordIndex,
            fieldGroupDialog.multipleParentId
          )
        "
        :key="fieldIndex"
        class="w-full"
      >
        <FormLabelComponent
          v-if="
            field.showLabel &&
            isIfConditionValid(
              field,
              fieldGroupDialog.recordIndex,
              fieldGroupDialog.multipleParentId
            )
          "
          :for-tag="field.id"
          :label="field.label"
          :required="field.required"
        />
        <FormInputComponent
          v-if="
            isIfConditionValid(
              field,
              fieldGroupDialog.recordIndex,
              fieldGroupDialog.multipleParentId
            )
          "
          :field="field"
          :updateLocalStore="updateLocalStore"
          :isMultiple="fieldGroupDialog.isMultiple"
          :recordIndex="fieldGroupDialog.recordIndex"
          :multipleParentId="fieldGroupDialog.multipleParentId"
          :clearOnHidden="field.clearOnHidden"
          :isVisible="
            isIfConditionValid(
              field,
              fieldGroupDialog.recordIndex,
              fieldGroupDialog.multipleParentId
            )
          "
          ref="formInputComponents"
          :ignoreOverridePageValue="ignoreOverridePageValue"
        />
      </div>

      <!-- Subpage group fields unsure if working -->
      <template v-if="fieldGroupDialog.subPageGroup">
        <div
          v-for="(
            subPageFieldGroup, subPageFieldsIndex
          ) in fieldGroupDialog.subPageGroup"
          :key="subPageFieldsIndex"
        >
          <Divider v-if="subPageFieldGroup.show_divider" />
          <div
            class="flex flex-wrap sm:flex-nowrap sm:items-center gap-2 pt-2"
            v-if="
              (subPageFieldGroup.showContainMatch &&
                compareContainMatchForSubFields(
                  subPageFieldGroup,
                  multipleFieldGroupArray[fieldGroupDialog.multipleParentId][
                    fieldGroupDialog.recordIndex
                  ],
                  fieldGroupDialog.recordIndex
                )) ||
              (!subPageFieldGroup.showContainMatch &&
                !subPageFieldGroup.group?.some((field) =>
                  field.label?.startsWith('$(')
                ))
            "
          >
            <div
              v-for="(
                subPageField, subPageFieldIndex
              ) in subPageFieldGroup.group"
              :key="subPageFieldIndex"
              class="w-full"
            >
              <FormLabelComponent
                v-if="
                  subPageField.showLabel &&
                  isIfConditionValid(
                    subPageField,
                    fieldGroupDialog.recordIndex,
                    fieldGroupDialog.multipleParentId
                  )
                "
                :for-tag="subPageField.id"
                :label="subPageField.label"
                :required="subPageField.required"
              />
              <FormInputComponent
                v-if="
                  isIfConditionValid(
                    subPageField,
                    fieldGroupDialog.recordIndex,
                    fieldGroupDialog.multipleParentId
                  )
                "
                :field="subPageFieldGroup.group[subPageFieldIndex]"
                :updateLocalStore="updateLocalStore"
                :isSubPage="true"
                :recordIndex="subPageFieldsIndex"
                :rowGroup="subPageFieldGroup"
                :multipleParentId="{
                  rowId: fieldGroupDialog.multipleParentId,
                  recordIndex: fieldGroupDialog.recordIndex
                }"
                :clearOnHidden="subPageField.clearOnHidden"
                :isVisible="
                  isIfConditionValid(
                    subPageField,
                    fieldGroupDialog.recordIndex,
                    fieldGroupDialog.multipleParentId
                  )
                "
                ref="formInputComponents"
                :ignoreOverridePageValue="true"
              />
            </div>
          </div>
        </div>
      </template>

      <!-- Dialog Description Bottom -->
      <FormInputComponent
        v-if="
          fieldGroupDialog.dialogDescription &&
          fieldGroupDialog.dialogDescription.position === 'bottom'
        "
        :field="fieldGroupDialog.dialogDescription"
        :updateLocalStore="false"
        :clearOnHidden="fieldGroupDialog.dialogDescription?.clearOnHidden"
        :isVisible="true"
        :ignoreOverridePageValue="ignoreOverridePageValue"
      />

      <!-- Dialog Footer Buttons -->
      <div class="flex justify-end gap-2 mt-4">
        <Button
          label="Close"
          severity="secondary"
          @click="cancelDialogChanges"
        />
        <Button
          label="Confirm"
          severity="primary"
          @click="confirmDialogChanges"
        />
      </div>
    </div>
  </Dialog>

  <ErrorDialog
    :visible="errorObj.isVisible"
    :message="errorObj.errorMsg"
    :onConfirm="onErrorDialogClose"
    @update:visible="errorObj.isVisible = $event"
  />
</template>

<script>
  import { defineComponent, watch, ref, onMounted, computed } from "vue";
  import FormLabelComponent from "@/components/FormLabelComponent.vue";
  import FormInputComponent from "@/components/FormInputComponent.vue";
  import AttachmentsGridComponent from "@/components/AttachmentsGridComponent.vue";
  import Helper from "@/utils/helper";
  import Constants from "@/utils/constants";
  import ErrorDialog from "@/components/ErrorDialog.vue";
  import { useFormTemplateResponseStore } from "@/stores/formTemplateResponseStore";
  import { storeToRefs } from "pinia";
  import { usePreDefinedListStore } from "../stores/preDefinedListStore";
  import { useFormPageStore } from "@/stores/formPageStore";
  import { debounce } from "lodash";

  export default defineComponent({
    name: "PageBuilderComponent",
    components: {
      FormLabelComponent,
      FormInputComponent,
      AttachmentsGridComponent,
      ErrorDialog
    },
    props: {
      page: {
        type: Object,
        required: true
      },
      multiArrayResItems: {
        type: Object,
        required: false
      },
      savedResValue: {
        type: Object,
        required: false
      },
      updateLocalStore: {
        type: Boolean,
        required: false,
        default: true
      },
      conditionCheckResponse: {
        type: Object,
        required: false,
        default: null
      },
      templateData: {
        type: Object,
        required: false,
        default: null
      },
      selectedPath: {
        type: Array,
        default: () => []
      },
      selectedLabels: {
        type: Array,
        default: () => []
      },
      ignoreOverridePageValue: {
        type: Boolean,
        default: false
      }
    },
    emits: ["update:page"],
    setup(props, { emit }) {
      const errorObj = ref({
        isVisible: false,
        errorMsg: ""
      });
      const localPage = ref(props.page);
      const formTemplateResponseStore = useFormTemplateResponseStore();
      const { response, templateId } = storeToRefs(formTemplateResponseStore);
      const formInputComponents = ref([]);

      // Check if a specific field should be disabled based on its conditions
      const checkFieldDisabled = (field) => {
        return false;
        try {
          // Check if the field has its own disabled_condition
          if (field.disabled_condition) {
            // Evaluate the field-specific condition against the current response state
            return Helper.evaluateTriggerConditions(
              field.disabled_condition.if_condition,
              response.value
            );
          }

          // If no field-specific condition, use the global disabled state
          return field.disabled || false;
        } catch (error) {
          console.error("Error evaluating field disabled condition:", error);
          return field.disabled || false;
        }
      };

      // Apply disabled property to fields if condition is true
      const applyDisabledToFields = () => {
        return {
          isDisabled: false,
          whitelist: []
        };
        if (!localPage.value.pageObj || !localPage.value.pageObj.fields) {
          return;
        }
        const disableSettings = localPage.value.pageObj.settings?.disable;

        let disableStates = [];
        if (disableSettings) {
          const disableArray = Array.isArray(disableSettings)
            ? disableSettings
            : [disableSettings];

          // Normalize disable config into an array to handle both single and multiple rules
          disableStates = disableArray.map((item) => {
            const isDisabled = Helper.evaluateTriggerConditions(
              item.condition,
              response.value
            );
            return {
              isDisabled,
              whitelist: item.whitelist || []
            };
          });
        }

        const isFieldDisabledFinal = (field) => {
          // First check field-specific conditions
          const isFieldDisabled = checkFieldDisabled(field);

          // Then apply page-level disabled state if:
          // 1. Field is not in whitelist AND
          // 2. Page is disabled AND
          // 3. Field is not already disabled by its own conditions
          const isGloballyDisabled = disableStates.some(
            (state) => state.isDisabled && !state.whitelist.includes(field.id)
          );

          return isFieldDisabled || isGloballyDisabled;
        };

        // Apply disabled property to all fields
        localPage.value.pageObj.fields.forEach((fieldGroup) => {
          if (fieldGroup.group) {
            fieldGroup.group.forEach((field) => {
              field.disabled = isFieldDisabledFinal(field);
            });
          }
        });

        // Also apply to multiple field groups
        Object.keys(multipleFieldGroupArray.value).forEach((key) => {
          multipleFieldGroupArray.value[key].forEach((record) => {
            if (record.group) {
              record.group.forEach((field) => {
                field.disabled = isFieldDisabledFinal(field);
              });
            }
          });
        });
      };

      // Method to generate autoincrement value for a specific field
      const generateAutoIncrementValue = async (
        id,
        shouldReturnVal = false
      ) => {
        try {
          // Find the field in the form input components
          for (const component of formInputComponents.value) {
            if (component && component.field && component.field.id === id) {
              return await component.generateAutoIncrementValue(
                shouldReturnVal
              );
            }
          }
        } catch (error) {
          errorObj.value.isVisible = true;
          errorObj.value.errorMsg = error;
        }
      };

      watch(
        localPage,
        (newVal, o) => {
          // applyDisabledToFields();
          try {
            // Emit changes to the parent
            emit("update:page", newVal);
          } catch (error) {
            errorObj.value.isVisible = true;
            errorObj.value.errorMsg = error;
          }
        },
        { deep: true }
      );

      // Watch response changes to update field disabled states
      watch(
        () => response.value,
        debounce(() => {
          // applyDisabledToFields();
        }, 500),
        { deep: true }
      );

      const multipleFieldGroupArray = ref({});
      const multipleFieldGroupEmptyObj = ref({});

      const onQAQCRemoveItemClick = (fieldGroup, index) => {
        try {
          multipleFieldGroupArray.value[fieldGroup.row_id].splice(index, 1);
          // get the current data
          let _groupData = Helper.findAndSetKeyInObject(
            Helper.deepCopy(response.value),
            fieldGroup.row_id
          );
          // remove the item from the current data
          _groupData.splice(index, 1);
          // update the response in the store
          formTemplateResponseStore.setResponse(
            props.selectedPath[props.selectedPath.length - 1],
            {
              [fieldGroup.row_id]: _groupData
            }
          );
          Helper.showToast("Successful", "Item removed successfully");
        } catch (error) {
          errorObj.value.isVisible = true;
          errorObj.value.errorMsg = error;
        }
      };
      const onQAQCAddMoreClick = (fieldGroup) => {
        try {
          // pull the current page id from the selected path
          let selectedPageId =
            props.selectedPath[props.selectedPath.length - 1];
          // pull the current page data from the saved res value
          let currentPageData = Helper.findAndSetKeyInObject(
            Helper.deepCopy(response.value || {}),
            selectedPageId
          );
          // now from the context of the current page, pull the data for the field group
          let _groupData = currentPageData
            ? currentPageData[fieldGroup.row_id]
            : null;

          // Initialize as empty array if null or undefined
          if (!_groupData) {
            _groupData = [];
          }

          // If _groupData is not an array, convert it to array
          if (!Array.isArray(_groupData)) {
            _groupData = Helper.convertObjectToArray(_groupData);
          }

          // add a new empty object to the current data
          _groupData.push(Helper.copyWithNullValues(_groupData[0]));

          // update the multiple field group array
          if (!multipleFieldGroupArray.value[fieldGroup.row_id]) {
            multipleFieldGroupArray.value[fieldGroup.row_id] = [];
          }
          let _temp = multipleFieldGroupEmptyObj.value[fieldGroup.row_id];

          multipleFieldGroupArray.value[fieldGroup.row_id].push(
            Helper.deepCopy(_temp)
          );

          // update the response in the store
          formTemplateResponseStore.setResponse(selectedPageId, {
            [fieldGroup.row_id]: _groupData
          });

          // open the dialog automatically if the mobile size is true
          if (Helper.isMobileSize()) {
            const newRecordIndex =
              multipleFieldGroupArray.value[fieldGroup.row_id].length - 1;
            const newFieldGroup =
              multipleFieldGroupArray.value[fieldGroup.row_id][newRecordIndex];
            openFieldGroupDialog(newFieldGroup, newRecordIndex, true);
          }

          Helper.showToast("Successful", "Item added successfully");
        } catch (error) {
          errorObj.value.isVisible = true;
          errorObj.value.errorMsg = error;
        }
      };
      const onRemoveItemClick = (fieldGroup, index) => {
        try {
          // it is dialogue on dialog so we need to call the onQAQCRemoveItemClick
          if (props.selectedPath && props.selectedPath.length > 0) {
            onQAQCRemoveItemClick(fieldGroup, index);
            return;
          }
          multipleFieldGroupArray.value[fieldGroup.row_id].splice(index, 1);
          // get the current data
          let _groupData = Helper.findAndSetKeyInObject(
            Helper.deepCopy(response.value),
            fieldGroup.row_id
          );
          // remove the item from the current data
          _groupData.splice(index, 1);
          // update the response in the store
          formTemplateResponseStore.setResponse(fieldGroup.row_id, _groupData);
          Helper.showToast("Successful", "Item removed successfully");
        } catch (error) {
          errorObj.value.isVisible = true;
          errorObj.value.errorMsg = error;
        }
      };
      const onAddMoreClick = (fieldGroup) => {
        try {
          // it is dialogue on dialog so we need to call the onQAQCAddMoreClick
          if (props.selectedPath && props.selectedPath.length > 0) {
            onQAQCAddMoreClick(fieldGroup);
            return;
          }
          // get the current data
          let _groupData = Helper.findAndSetKeyInObject(
            Helper.deepCopy(response.value),
            fieldGroup.row_id
          );
          // add a new empty object to the current data
          _groupData.push(Helper.copyWithNullValues(_groupData[0]));

          // update the multiple field group array
          if (!multipleFieldGroupArray.value[fieldGroup.row_id]) {
            multipleFieldGroupArray.value[fieldGroup.row_id] = [];
          }
          let _temp = multipleFieldGroupEmptyObj.value[fieldGroup.row_id];

          multipleFieldGroupArray.value[fieldGroup.row_id].push(
            Helper.deepCopy(_temp)
          );

          // update the response in the store
          formTemplateResponseStore.setResponse(fieldGroup.row_id, _groupData);

          // open the dialog automatically if the mobile size is true
          if (Helper.isMobileSize()) {
            const newRecordIndex =
              multipleFieldGroupArray.value[fieldGroup.row_id].length - 1;
            const newFieldGroup =
              multipleFieldGroupArray.value[fieldGroup.row_id][newRecordIndex];
            openFieldGroupDialog(newFieldGroup, newRecordIndex, true);
          }

          Helper.showToast("Successful", "Item added successfully");
        } catch (error) {
          errorObj.value.isVisible = true;
          errorObj.value.errorMsg = error;
        }
      };
      const getPredefinedListData = async (refId) => {
        try {
          return await usePreDefinedListStore().getPreDefinedListById(refId);
        } catch (error) {
          errorObj.value.isVisible = true;
          errorObj.value.errorMsg = error;
        }
      };
      onMounted(async () => {
        try {
          for (const fieldGroup of localPage.value.pageObj.fields) {
            // if EDIT mode then pull existing data from the savedResValue
            let currentVal = Helper.findAndSetKeyInObject(
              Helper.deepCopy(response.value || {}),
              fieldGroup.row_id
            );
            if (fieldGroup.is_multiple) {
              if (props.selectedPath && props.selectedPath.length > 0) {
                // pull the current page id from the selected path
                let selectedPageId =
                  props.selectedPath[props.selectedPath.length - 1];
                // pull the current page data from the saved res value
                let currentPageData = Helper.findAndSetKeyInObject(
                  Helper.deepCopy(response.value || {}),
                  selectedPageId
                );
                // now from the context of the current page, pull the data for the field group
                currentVal = currentPageData
                  ? currentPageData[fieldGroup.row_id]
                  : null;
                if (typeof currentVal === "object") {
                  currentVal = Helper.convertObjectToArray(currentVal);
                }
              } else {
                currentVal = Helper.findAndSetKeyInObject(
                  Helper.deepCopy(response.value || {}),
                  fieldGroup.row_id
                );
              }

              // create a new empty object for the field group
              let _temp = Helper.deepCopy(fieldGroup);
              _temp.group = await Promise.all(
                _temp.group.map(async (item) => ({
                  ...item,
                  value: null
                }))
              );
              // add the new empty object to the multiple field group array to be used when adding a new item
              multipleFieldGroupEmptyObj.value[fieldGroup.row_id] = _temp;

              if (fieldGroup.sub_page_id) {
                multipleFieldGroupEmptyObj.value[
                  fieldGroup.row_id
                ].sub_page_group = [];
                // get the sub page
                const _subFormPage = await useFormPageStore().getFormPageById(
                  fieldGroup.sub_page_id,
                  true
                );
                if (_subFormPage.error) throw _subFormPage.error;
                for (const subPagefieldGroup of _subFormPage.data.fields) {
                  // adding the sub page field group to the current field group
                  multipleFieldGroupEmptyObj.value[
                    fieldGroup.row_id
                  ].sub_page_group.push(subPagefieldGroup);
                  //  if needs to create a UI based on options_ref
                  if (subPagefieldGroup.options_ref) {
                    // get the predefined list data based on ref
                    let _list = await getPredefinedListData(
                      subPagefieldGroup.options_ref
                    );
                    // Create entries based on predefined list length
                    for (let i = 0; i < _list.length; i++) {
                      let fieldGroupCopy = Helper.deepCopy(subPagefieldGroup);

                      // Update labels with dynamic values from corresponding list item
                      for (const item of fieldGroupCopy.group) {
                        if (item.label) {
                          Object.assign(item, {
                            ...item,
                            label: Helper.findDynamicKeyInExpression(
                              item.label,
                              Helper.deepCopy(_list[i])
                            ),
                            value: Helper.findDynamicKeyInExpression(
                              item.label,
                              Helper.deepCopy(_list[i])
                            )
                          });
                          fieldGroupCopy.meta_data = Helper.deepCopy(_list[i]);
                        }
                      }

                      // If we have saved values, use them
                      if (currentVal && currentVal[i]) {
                        fieldGroupCopy.group = await Promise.all(
                          fieldGroupCopy.group.map(async (item) => ({
                            ...item,
                            value: currentVal[i][item.id] || item.value || null
                          }))
                        );
                      }
                      multipleFieldGroupEmptyObj.value[
                        fieldGroup.row_id
                      ].sub_page_group.push(fieldGroupCopy);
                    }
                  }
                }
              }

              // if the multiple field group array is not exist then create a new one
              if (!multipleFieldGroupArray.value[fieldGroup.row_id]) {
                multipleFieldGroupArray.value[fieldGroup.row_id] = [];
              }
              // Handle case when no options_ref (original behavior)
              if (!currentVal) {
                multipleFieldGroupArray.value[fieldGroup.row_id] = [];
                multipleFieldGroupArray.value[fieldGroup.row_id].push(
                  Helper.deepCopy(
                    multipleFieldGroupEmptyObj.value[fieldGroup.row_id]
                  )
                );
              } else {
                // THIS IS TO FILL THE DATA BACK TO THE FIELDS
                let _temp = Helper.deepCopy(
                  multipleFieldGroupEmptyObj.value[fieldGroup.row_id]
                );
                for (const itemValue of currentVal) {
                  // Handle main group fields
                  _temp.group = await Promise.all(
                    _temp.group.map(async (item) => ({
                      ...item,
                      value: itemValue[item.id] || item.value || null
                    }))
                  );

                  // Handle the each sub page
                  if (_temp.sub_page_group) {
                    _temp.sub_page_group = await Promise.all(
                      _temp.sub_page_group.map(async (subGroup, index) => {
                        // will return the value if exists and if obj doesn't exists then return null means no value
                        let _value = (itemId) => {
                          try {
                            return itemValue["sub_page"][index][itemId] || null;
                          // eslint-disable-next-line no-unused-vars
                          } catch (_) {
                            return null;
                          }
                        }
                          subGroup.group = await Promise.all(
                            subGroup.group.map(async (item) => ({
                              ...item,
                              value:
                                _value(item.id)
                            }))
                          );
                        return subGroup;
                      })
                    );
                  }
                  multipleFieldGroupArray.value[fieldGroup.row_id].push(
                    Helper.deepCopy(_temp)
                  );
                }
              }
            }
          }

          // Apply disabled property to fields if condition is true
          // applyDisabledToFields();
        } catch (error) {
          errorObj.value.isVisible = true;
          errorObj.value.errorMsg = error;
        }
      });

      const onErrorDialogClose = () => {
        errorObj.value.isVisible = false;
        errorObj.value.errorMsg = "";
      };

      // update the attachments in the response on remove
      const onUpdateAttachments = (attachments, fieldId = null) => {
        // get the current data with setting up updated attachments
        let _groupData = null;
        // if the selected path is exist then use it, otherwise use the field id
        if (props.selectedPath && props.selectedPath.length > 0) {
          const pathString = [...props.selectedPath, fieldId].join(".");
          _groupData = Helper.setValueByPath(
            Helper.deepCopy(response.value),
            pathString,
            attachments
          );
        } else {
          _groupData = Helper.findAndSetKeyInObject(
            Helper.deepCopy(response.value),
            fieldId,
            attachments
          );
        }
        // update the response in the store
        formTemplateResponseStore.setResponse(
          templateId.value,
          _groupData[templateId.value]
        );
      };

      // Check if any field in a group is disabled
      const isAnyFieldDisabled = (fields) => {
        return false;
        if (!fields || fields.length === 0) {
          return false;
        }
        return fields.some((field) => field.disabled);
      };
      // we've special case example, if it's multiple, then we're passing the record id and the parent obj id to fetch exact row data and that data will get passed for the validation instead of response.value
      const isIfConditionValid = (field, index, recordGroupId) => {
        const responseToCheck = props.conditionCheckResponse || response.value;

        if (
          field &&
          Helper.isStringValueExist(field.if_condition) &&
          Helper.isValueExist(index) &&
          Helper.isValueExist(recordGroupId)
        ) {
          const parentResponse = Helper.findAndSetKeyInObject(
            Helper.deepCopy(responseToCheck),
            recordGroupId
          );
          return Helper.evaluateTriggerConditions(
            field.if_condition,
            parentResponse[index]
          );
        } else if (Helper.isStringValueExist(field.if_condition)) {
          return Helper.evaluateTriggerConditions(
            field.if_condition,
            Helper.deepCopy(responseToCheck)
          );
        }
        return true;
      };

      const compareContainMatchForSubFields = (
        subPageFieldGroup,
        record,
        recordIndex
      ) => {
        const parentResponse = Helper.findAndSetKeyInObject(
          Helper.deepCopy(response.value),
          record.row_id
        );
        const dynamicKey = Helper.findDynamicKeyInExpression(
          subPageFieldGroup.showContainMatch,
          Helper.deepCopy(parentResponse[recordIndex])
        );
        if (
          subPageFieldGroup &&
          subPageFieldGroup.meta_data &&
          Helper.isStringValueExist(dynamicKey)
        ) {
          return Object.values(subPageFieldGroup.meta_data).includes(
            dynamicKey
          );
        }
        return false;
      };

      const isSubPageExpanded = ref({});

      const toggleSubPage = (recordIndex) => {
        isSubPageExpanded.value[recordIndex] =
          !isSubPageExpanded.value[recordIndex];
      };

      const validatePage = () => {
        let isValid = true;
        const invalidFields = [];

        // Helper function to find form input component with metadata check
        // For sub_page fields, pass parentRecordIndex and parentRowId to match the specific parent row's component
        const findFormInputComponent = (
          field,
          metadata = null,
          recordIndex = null,
          parentRecordIndex = null,
          parentRowId = null
        ) => {
          return formInputComponents.value.find((component) => {
            if (!component || !component.field) return false;

            // For regular fields, match by ID + label
            if (!metadata && recordIndex === null) {
              if (field.strictMatching) {
                return (
                  component.field.id === field.id &&
                  component.field.label === field.label
                );
              }
              return component.field.id === field.id;
            }
            // For sub_page fields, match by field ID, recordIndex (subPageIndex), and parent row (multipleParentId)
            if (
              parentRecordIndex !== null &&
              parentRowId != null &&
              component.multipleParentId
            ) {
              const parentId =
                typeof component.multipleParentId === "object"
                  ? component.multipleParentId
                  : {};
              return (
                component.field.id === field.id &&
                component.recordIndex === recordIndex &&
                parentId.recordIndex === parentRecordIndex &&
                parentId.rowId === parentRowId
              );
            }
            // For multifield groups (non-sub_page), match ID and recordIndex; exclude sub_page components (multipleParentId as object)
            const isSubPageComponent =
              component.multipleParentId &&
              typeof component.multipleParentId === "object" &&
              "rowId" in component.multipleParentId;
            return (
              !isSubPageComponent &&
              component.field.id === field.id &&
              component.recordIndex === recordIndex
            );
          });
        };

        // Validate each field group
        for (const fieldGroup of localPage.value.pageObj.fields) {
          if (fieldGroup.group) {
            for (const field of fieldGroup.group) {
              // Skip validation if field is not visible due to if_condition
              if (field.required === false || !isIfConditionValid(field)) {
                continue;
              }

              const formInputComponent = findFormInputComponent(field);
              if (formInputComponent) {
                const validation = formInputComponent.applyValidationState();
                if (!validation) {
                  isValid = false;
                  invalidFields.push(field);
                }
              }
            }
          }
        }

        // Validate multiple field groups if they exist
        if (multipleFieldGroupArray.value) {
          for (const [key, groups] of Object.entries(
            multipleFieldGroupArray.value
          )) {
            for (
              let recordIndex = 0;
              recordIndex < groups.length;
              recordIndex++
            ) {
              const group = groups[recordIndex];
              for (const field of group.group) {
                // Skip validation if field is not visible due to if_condition
                if (
                  field.required === false ||
                  !isIfConditionValid(field, recordIndex, group.row_id)
                ) {
                  continue;
                }

                const formInputComponent = findFormInputComponent(
                  field,
                  group.meta_data,
                  recordIndex
                );
                if (formInputComponent) {
                  const validation = formInputComponent.applyValidationState();
                  if (!validation) {
                    isValid = false;
                    invalidFields.push(field);
                  }
                }
              }

              // Validate subpage fields if they exist
              if (group.sub_page_group) {
                for (
                  let subPageIndex = 0;
                  subPageIndex < group.sub_page_group.length;
                  subPageIndex++
                ) {
                  const subPageGroup = group.sub_page_group[subPageIndex];

                  // Skip validation if subpage group is not visible due to showContainMatch
                  if (
                    subPageGroup.showContainMatch &&
                    !compareContainMatchForSubFields(
                      subPageGroup,
                      group,
                      recordIndex
                    )
                  ) {
                    continue;
                  }

                  if (subPageGroup.group) {
                    for (const field of subPageGroup.group) {
                      // Skip validation if field is not required or not visible due to if_condition
                      const isRequired = field.required !== false;
                      const isConditionValid = isIfConditionValid(field, recordIndex, group.row_id);
                      if (!isRequired || !isConditionValid) {
                        continue;
                      }

                      // Match sub_page component by field, subPageIndex, and parent row (recordIndex + rowId)
                      const formInputComponent = findFormInputComponent(
                        field,
                        subPageGroup.meta_data,
                        subPageIndex,
                        recordIndex,
                        group.row_id
                      );
                      if (formInputComponent) {
                        const validation =
                          formInputComponent.applyValidationState();
                        if (!validation) {
                          isValid = false;
                          invalidFields.push(field);
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }

        // Process custom page validation from template settings
        if (props.templateData?.settings) {
          const pageValidationResult = Helper.processPageValidation(
            props.templateData.settings,
            localPage.value.id,
            response.value
          );

          console.log("pageValidationResult :", pageValidationResult);

          if (!pageValidationResult.isValid) {
            isValid = false;

            // Apply validation state to invalid fields from page validation
            for (const fieldId of pageValidationResult.invalidFields) {
              // Find the field in all field groups
              let foundField = null;

              // Search in regular field groups
              for (const fieldGroup of localPage.value.pageObj.fields) {
                if (fieldGroup.group) {
                  foundField = fieldGroup.group.find((f) => f.id === fieldId);
                  if (foundField) break;
                }
              }

              // Search in multiple field groups if not found
              if (!foundField && multipleFieldGroupArray.value) {
                for (const [key, groups] of Object.entries(
                  multipleFieldGroupArray.value
                )) {
                  for (const group of groups) {
                    foundField = group.group.find((f) => f.id === fieldId);
                    if (foundField) break;
                  }
                  if (foundField) break;
                }
              }

              // Apply validation state if field is found
              if (foundField) {
                const formInputComponent = findFormInputComponent(foundField);
                if (formInputComponent) {
                  formInputComponent.applyValidationState({
                    isValid: false,
                    message: "Invalid"
                  });
                }

                invalidFields.push(foundField);
              }
            }
          }
        }

        return {
          isValid,
          invalidFields
        };
      };

      // Method to scroll to first invalid field
      const scrollToInvalidField = (field) => {
        const element = document.getElementById(field.id);
        if (element) {
          element.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      };

      const fieldGroupDialog = ref({
        visible: false,
        title: "",
        fields: [],
        isMultiple: false,
        recordIndex: null,
        multipleParentId: null,
        subPageGroup: null,
        isFullscreen: false
      });

      // Backup state for dialog changes
      const dialogBackupState = ref(null);
      const isDialogClosingProgrammatically = ref(false);

      const openFieldGroupDialog = (
        fieldGroup,
        recordIndex = null,
        isMultiple = false
      ) => {
        // Save the current response state before opening dialog
        dialogBackupState.value = Helper.deepCopy(response.value);
        isDialogClosingProgrammatically.value = false;

        fieldGroupDialog.value = {
          visible: true,
          title: fieldGroup.title || "Field Group",
          fields: fieldGroup.group,
          isMultiple: isMultiple,
          recordIndex: recordIndex,
          multipleParentId: fieldGroup.row_id,
          subPageGroup: fieldGroup.sub_page_group,
          isFullscreen: fieldGroup.dialog_fullscreen,
          dialogDescription: fieldGroup.dialog_description,
          dialogButtons: fieldGroup.dialog_buttons
        };
      };

      const confirmDialogChanges = () => {
        const validation = validatePage();
        if (!validation.isValid) {
          if (validation.invalidFields.length > 0) {
            scrollToInvalidField(validation.invalidFields[0]);
          }
          return;
        }
        // Keep the changes - no need to revert
        isDialogClosingProgrammatically.value = true;
        fieldGroupDialog.value.visible = false;
        dialogBackupState.value = null;
      };

      const cancelDialogChanges = () => {
        // Revert to the backup state
        isDialogClosingProgrammatically.value = true;
        if (dialogBackupState.value) {
          formTemplateResponseStore.setInitialResponse(dialogBackupState.value);
        }
        fieldGroupDialog.value.visible = false;
        dialogBackupState.value = null;
      };

      // Watch for dialog visibility changes to handle external closures
      watch(
        () => fieldGroupDialog.value.visible,
        (newVal, oldVal) => {
          // If dialog was closed externally (not through our buttons) and we have backup state
          if (
            oldVal === true &&
            newVal === false &&
            dialogBackupState.value &&
            !isDialogClosingProgrammatically.value
          ) {
            // Revert changes
            formTemplateResponseStore.setInitialResponse(
              dialogBackupState.value
            );
            dialogBackupState.value = null;
          }
          // Reset the flag after the change
          isDialogClosingProgrammatically.value = false;
        }
      );

      const isFieldHidden = (field) => {
        return Helper.isFieldHidden(field, response.value);
      };

      const getCardDialogStyle = computed(() => {
        if (fieldGroupDialog.value.isFullscreen) {
          return {
            width: "100vw",
            height: "100vh",
            maxHeight: "100vh"
          };
        }
        return { width: "90vw", maxWidth: "600px" };
      });

      const isCardEmpty = (
        cardTitle,
        cardBody,
        recordIndex,
        multipleParentId
      ) => {
        let context =
          multipleParentId && recordIndex >= 0
            ? Helper.findAndSetKeyInObject(response.value, multipleParentId)[
                recordIndex
              ] || {}
            : response.value;

        // Check if any dynamic value has content
        const hasDynamicContent = (label) => {
          const matches = label?.match(/\$\([^)]+\)/g);
          return matches?.some((match) =>
            Helper.findDynamicKeyInExpression(match, context)?.trim()
          );
        };

        return (
          !hasDynamicContent(cardTitle?.label) &&
          !hasDynamicContent(cardBody?.label)
        );
      };

      const getFallbackMessage = (fieldGroup) => {
        return fieldGroup.fallback_message || "Click or tap here to open it";
      };

      return {
        errorObj,
        Helper,
        Constants,
        localPage,
        onAddMoreClick,
        onRemoveItemClick,
        multipleFieldGroupArray,
        onErrorDialogClose,
        onUpdateAttachments,
        formInputComponents,
        generateAutoIncrementValue,
        isAnyFieldDisabled,
        isIfConditionValid,
        getPredefinedListData,
        compareContainMatchForSubFields,
        isSubPageExpanded,
        toggleSubPage,
        validatePage,
        scrollToInvalidField,
        fieldGroupDialog,
        openFieldGroupDialog,
        confirmDialogChanges,
        cancelDialogChanges,
        isFieldHidden,
        getCardDialogStyle,
        isCardEmpty,
        getFallbackMessage
      };
    }
  });
</script>
